module.exports = __webpack_public_path__ + "img/matrix-wordmark.33f68e40.svg";